import { Injectable, inject } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { DictionaryGlobalStore } from '../../dictionary/store/dictionary-global.store';
import { RecordsGlobalStore } from '../../records/store/records-global.store';
import { environment } from '../../../environments/environment';

@Injectable()
export class SdPageTitleStrategy extends TitleStrategy {
  private readonly titleService = inject(Title);
  private readonly dictStore = inject(DictionaryGlobalStore);
  private readonly recordsGlobalStore = inject(RecordsGlobalStore);

  constructor() {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot) {
    const title = this.buildTitle(snapshot);
    if (!title) {
      this.titleService.setTitle(environment.defaultPageTitle ?? 'SideDrawer');
      return;
    }
    if (title === 'activeRecordTypeName') {
      const recordType = this.recordsGlobalStore.activeRecordType();
      if (!recordType) {
        this.titleService.setTitle(
          environment.defaultPageTitle ?? 'SideDrawer'
        );
      } else {
        this.titleService.setTitle(
          recordType?.displayValue[0]?.value ??
            environment.defaultPageTitle ??
            'SideDrawer'
        );
      }
      return;
    }
    const dictionary = this.dictStore.dictionary();
    if (!dictionary) {
      this.titleService.setTitle(environment.defaultPageTitle ?? 'SideDrawer');
      return;
    }
    this.titleService.setTitle(dictionary?.[title] ?? title);
  }
}
